export enum AccLevel {
  All = 999,

  /// <summary>
  /// Tài khoản super
  /// </summary>
  Master = 0,

  /// <summary>
  /// Tài khoản quản lý
  /// </summary>
  Admin = 1,

  /// <summary>
  /// Đại lý
  /// </summary>
  Agent = 2,

  /// <summary>
  /// Tài khoản công ty
  /// </summary>
  Company = 3,

  /// <summary>
  /// Cộng tác viên
  /// </summary>
  Partner = 5,

  /// <summary>
  /// Booker
  /// </summary>
  Booker = 6,

  /// <summary>
  /// Nhân viên
  /// </summary>
  Staff = 7,

  /// <summary>
  /// Khách hàng
  /// </summary>
  Customer = 8,
}
